import { render, staticRenderFns } from "./StatusRemocaoIcon.vue?vue&type=template&id=31b4a050&scoped=true"
import script from "./StatusRemocaoIcon.vue?vue&type=script&lang=js"
export * from "./StatusRemocaoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4a050",
  null
  
)

export default component.exports